import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = "https://ecom.cyberathon.com";

const ContactsAPI = () => {
  const [contactInfo, setContactInfo] = useState({
    full_name: "",
    email: "",
    mobile: "",
    message: "",
    location: "",
    phone: "",
    support_email: ""
  });

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile: "",
    message: ""
  });

  // Fetch contact info dynamically (using first item from admin panel list)
  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await axios.get(BASE_URL + "/index.php/Api/get_contact_list");

        if (res.data.data && res.data.data.length > 0) {
          const c = res.data.data[0]; // taking first record
          setContactInfo({
            ...contactInfo,
            location: c.location || "Shop no. 10, Warud, Maharashtra",
            phone: c.mobile || "0000000000",
            support_email: c.email || "support@example.com",
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchContactInfo();
  }, []);

  // Handle form input
  const handleInput = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        BASE_URL + "/index.php/Api/insert_contact_list_data",
        form
      );

      if (res.data.status === true) {
        toast.success("Message sent successfully!");
        setForm({ full_name: "", email: "", mobile: "", message: "" });
      } else {
        toast.error("Failed to send message");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="container-fluid py-5 px-3 px-md-5">

      <div className="text-center mb-5">
        <h6 className="fw-bold text-uppercase">Get in Touch</h6>
        <h1 className="fw-bold display-6">Contact Us</h1>
      </div>

      <div className="row g-4 justify-content-center">

        {/* LEFT SIDE DETAILS (Dynamic) */}
        <div className="col-12 col-lg-6">

          <div className="d-flex align-items-start shadow-sm rounded p-4 bg-white mb-4 border border-2">
            <i className="bi bi-geo-alt fs-1 me-3 p-3 bg-icon"></i>
            <div>
              <h5 className="fw-bold mb-1">Our Location</h5>
              <p className="mb-0">
                {contactInfo.location}
              </p>
            </div>
          </div>

          <div className="d-flex align-items-start shadow-sm rounded p-4 bg-white mb-4 border border-2">
            <i className="bi bi-telephone-inbound fs-1 me-3 p-3 bg-icon"></i>
            <div>
              <h5 className="fw-bold mb-1">Call Us</h5>
              <p className="mb-0">{contactInfo.phone}</p>
              <p className="mb-0">Mon–Sat, 9:00 AM – 7:00 PM</p>
            </div>
          </div>

          <div className="d-flex align-items-start shadow-sm rounded p-4 bg-white border border-2">
            <i className="bi bi-envelope fs-1 me-3 p-3 bg-icon"></i>
            <div>
              <h5 className="fw-bold mb-1">Email</h5>
              <p className="mb-0">{contactInfo.support_email}</p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-12 col-lg-6">
          <div className="bg-white rounded shadow-sm p-md-5 px-3 border border-2">
            <h4 className="fw-bold mb-3 text-center">Send Us a Message</h4>

            <form onSubmit={submitForm}>
              <div className="mb-3">
                <label className="form-label fw-bold">Full Name</label>
                <input
                  type="text"
                  className="form-control p-2"
                  name="full_name"
                  value={form.full_name}
                  onChange={handleInput}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Email</label>
                <input
                  type="email"
                  className="form-control p-2"
                  name="email"
                  value={form.email}
                  onChange={handleInput}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Mobile Number</label>
                <input
                  type="tel"
                  className="form-control p-2"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleInput}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  name="message"
                  value={form.message}
                  onChange={handleInput}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="border-0 rounded-1 text-light w-100 mt-2 py-2 fw-bold bg-col"
              >
                Send Message
              </button>
            </form>

          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactsAPI;
